import { AlmeApiBase } from '@alme/api-ts/Alme/AlmeApiBase';
import { LiveChatNotificationApiNext } from '@alme/api-ts/LiveChat/LiveChatNotificationApi';
import { LiveChatNotificationApiBase } from '@alme/api-ts/LiveChat/LiveChatNotificationApiBase';
import { LiveChatNotificationApiSettings } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettings';
import { LiveChatNotificationApiSettingsBase } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettingsBase';
import { HttpHandlerBase } from '@alme/api-ts/HttpHandlerBase';
import defaultLogger from '../Logger';
import { isDebug } from '../utils/DebugUtils';
import { getLocation } from '../utils/UrlUtils';
import { AlmeApiNext } from '@alme/api-ts/Alme/AlmeApi';

export function createDefaultSettings(): LiveChatNotificationApiSettings {
    const apiSettings = new LiveChatNotificationApiSettingsBase();

    if (isDebug()) {
        // if running locally point to dev server.
        apiSettings.AlmeApiHostname = 'Niqanovalme101.ebu.nextnet.com';
        defaultLogger.warn('Using dev server: ', apiSettings.AlmeApiHostname);
    }
    else {
        const almeScriptLoader = document?.getElementById("alme-script-loader") as HTMLScriptElement;

        if (almeScriptLoader && almeScriptLoader.src) {
            const almeScriptLoaderUrl = getLocation(almeScriptLoader.src);
            apiSettings.AlmeApiHostname = almeScriptLoaderUrl.host;
        }
    }
    return apiSettings;
}

const httpHandler = new HttpHandlerBase();

export function createAlmeApi(almeApiSettings?: LiveChatNotificationApiSettings): AlmeApiNext {
    const apiSettings = almeApiSettings || createDefaultSettings();
    return new AlmeApiBase(defaultLogger, httpHandler, apiSettings);
}

export function createLiveChatNotificationApi(almeApiSettings?: LiveChatNotificationApiSettings): LiveChatNotificationApiNext {
    const apiSettings = almeApiSettings || createDefaultSettings();
    return new LiveChatNotificationApiBase(defaultLogger, httpHandler, apiSettings);
}
